export const accessLevels = ['admin', 'member', 'none'] as const

type AccessLevel = typeof accessLevels[number]
export default AccessLevel
